
    <span class="ant-breadcrumb-link">
      <ng-content></ng-content>
    </span>
    <span class="ant-breadcrumb-separator">
      <ng-container *ngIf="dwBreadCrumbComponent.isTemplateRef; else stringTemplate">
        <ng-template [ngTemplateOutlet]="dwBreadCrumbComponent.dwSeparator"></ng-template>
      </ng-container>
      <ng-template #stringTemplate>
         {{ dwBreadCrumbComponent.dwSeparator }}
      </ng-template>
    </span>